module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity3.728fa63d.jpg";